import { transparentize } from 'polished'
import styled, { css } from 'styled-components'
import { BLUE, BLUE_PRINCIPAL_90, DARK, GREEN, LIGHT_YELLOW, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

type ContainerProps = {
  variant?: 'primary' | 'secondary'
}

type NavProps = {
  $isVisible?: boolean
}

export const Container = styled.header<ContainerProps>`
  width: 100%;
  background: ${LIGHT_YELLOW};
  border-bottom: 1px solid ${transparentize(0.5, BLUE)};

  ${props => props.variant === 'secondary' && css`
  border-bottom: 1px solid ${transparentize(0.7, BLUE_PRINCIPAL_90)};
    background: #FAFAFA;
  `}

  @media (max-width: ${MD}) {
    border-bottom: none;
  }
`

export const Inside = styled.div`
  width: 100%;
  max-width: 1236px;
  margin: 0 auto;
  padding: 30px 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .menu {
    position: absolute;
    margin: 25px;
    border: none;
    background: transparent;
    display: none;

    @media (max-width: ${MD}) {
      display: block;
    }
  }


  .logo {
    img {
      width: 113px;

      @media (max-width: ${MD}) {
        width: 75px;
      }
    }

    @media (max-width: ${MD}) {
      margin: 0 auto;
    }
  }
`

export const Nav = styled.nav<NavProps>`
  font-size: 16px;
  font-weight: 500;

  ul {
    display: flex;
    align-items: center;

    li {
      margin: 19px;
      &.separator {
        &:before {
          content: '|';
          font-size: 18px;
          color: ${GREEN};
        }
      }

      a {
        color: ${transparentize(0.3, DARK)};
        text-decoration: none;
        &:hover {
          color: ${DARK};
        }
      }
    }
  }

  @media (max-width: ${MD}) {
    display: none;
    ${props => props.$isVisible && css`
      z-index: 1000;
      display: block;
      position: absolute;
      top: 50px;
      left: 74px;
      background: ${WHITE};
      border: 0.3px solid #C4C4C4;
      box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16);
      border-radius: 4px;
      padding-top: 16px;
      padding-bottom: 38px;

      ul {
        display: block;
        padding: 11px;
        li {
          margin: 0;
          padding: 0px 30px 0px 38px;
          height: 50px;

          .button {
            display: block;
            width: 100%;
          }

          &.separator {
            overflow: hidden;
            background-color: #C7C9D9;
            width: 100%;
            height: 1px;
            margin-bottom: 30px;
          }
        }
      }
    `}
  }
`
